import BigButton from "components/atoms/buttons/BigButton";
import { useMenu } from "hook/useMenu";
import styled from "styled-components";
import { FLEX } from "styles/flex";
import { calcRem } from "styles/theme";
import { RiPencilRuler2Fill } from "react-icons/ri";

export default function NoAlertRule() {
  const { menuNavigation } = useMenu({});

  return (
    <Container>
      <RiPencilRuler2Fill size={50} />
      <h1> No Alert Rules</h1>
      <BigButton
        label="Create Alert Rules"
        onClickBtn={() =>
          menuNavigation({
            to: `/alert/rules`,
          })
        }
        data-testid="blocks-no-alert-rule-tsx-blocks-button-menu-navigation"
      />
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  ${FLEX.FlexStartCenter};
  flex-direction: column;
  gap: 10px;
  flex: 1;

  > svg {
    color: ${({ theme }) => theme.COLORS.TEXT};
  }

  h1 {
    font-size: ${calcRem(20)};
    font-weight: 500;
    color: ${({ theme }) => theme.COLORS.WHITE};
  }
`;
